{
  "title": "AI Usage of {{email}}",
  "button": "My AI Usage",
  "model": "Model",
  "period": "Period",
  "periods-hourly": "Hourly",
  "periods-weekly": "Weekly",
  "periods-monthly": "Monthly",
  "prompt-tokens": "Prompt Tokens",
  "prompt-limit": "Limit (%)",
  "completion-tokens": "Completion Tokens",
  "completion-limit": "Limit (%)",
  "total-tokens": "Total Tokens",
  "total-limit": "Limit (%)",
  "requests": "Requests",
  "request-limit": "Limit (%)",
  "estimated-monthly-cost": "Estimated Monthly Cost",
  "prompt-cost": "Prompt Cost",
  "completion-cost": "Completion Cost",
  "total-cost": "Total Cost",
  "no-usage": "No usage data available",
  "request-failed": "Failed to load AI usage",
  "close": "Close"
}
